<template>
  <div id="ecommerce_product">
    <div v-if="state == 'list'">
      <v-container>
        <div
          :class="{
            'ketshop-bg-color':
              selectedBot.useketshop == true &&
              selectedBot.ketshop_api_key &&
              selectedBot.ketshop_api_secret
          }"
        >
          <v-layout wrap>
            <v-flex xs12 sm7 lg6 class="pl-1">
              <div class="pt-2">
                <multiselect
                  v-model="shop"
                  :options="shopOptions"
                  selectLabel
                  selectedLabel
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                  track-by="name"
                  label="name"
                  @select="onchangeshop"
                ></multiselect>
              </div>
              <img
                src="/static/img/assets/_global/ketshop_logo.svg"
                alt
                style="max-height: 101px; width: 150px"
                v-if="
                  selectedBot.useketshop == true &&
                  selectedBot.ketshop_api_key &&
                  selectedBot.ketshop_api_secret
                "
              />
            </v-flex>
            <v-flex xs12 sm5 lg6 class="form-control pa-2 text-xs-left text-sm-right">
              <v-layout>
                <v-flex>
                  <input
                    type="text"
                    class="form-control ma-0"
                    v-model="search"
                    :placeholder="$t('Search')"
                    v-if="categorylist && categorylist.length > 0 && productlist.length > 0"
                  />
                </v-flex>
                <transfer-shop></transfer-shop>
                <import-shop
                  v-if="$store.state.centralPage.includes(selectedBot.pageid) || !isFacebook"
                ></import-shop>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <template v-if="loadingCategory">
          <div style="padding: 30px 0">
            <scale-loader :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
          </div>
        </template>
        <template v-else-if="categorylist && categorylist.length == 0">
          <v-layout wrap>
            <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 230px" />
              <h3 class="headline">{{ $t('create your first category') }}</h3>
              <p>{{ $t('Click Add Category to create a category and add products') }}</p>
              <v-btn color="primary" depressed @click="showCategory = true">
                <em class="fa fa-plus middle mr-1" />
                {{ $t('Add new categories') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <v-layout wrap>
            <v-flex xs5>
              <h3 class="headline mt-2">{{ $t('Category') }}</h3>
            </v-flex>
            <v-flex xs7 text-xs-right>
              <v-btn
                small
                fab
                outline
                class="primary--text"
                @click="showCategory = true"
                v-if="
                  !(
                    selectedBot.useketshop == true &&
                    selectedBot.ketshop_api_key &&
                    selectedBot.ketshop_api_secret
                  )
                "
              >
                <em class="fa fa-pencil-alt middle" />
              </v-btn>
            </v-flex>
          </v-layout>
          <div style="overflow-x: auto; white-space: nowrap; padding-bottom: 15px">
            <filter-category
              :categories="filterCategory"
              v-model="currentCategory"
              @onChangeCategory="onChangeCategory"
              :stat="filterBadge"
            ></filter-category>
          </div>

          <v-divider></v-divider>
          <template v-if="currentCategory && currentCategory != null">
            <v-layout warp>
              <v-flex xs12 sm6>
                <h3 class="headline mt-3">{{ $t('Products') }}</h3>
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-right">
                <v-btn outline color="primary" @click="showSortProduct = true">
                  <v-icon class="mr-2">swap_vert</v-icon>
                  {{ $t('sort product') }}
                </v-btn>
                <template v-if="showSortProduct">
                  <sort-product
                    v-model="showSortProduct"
                    :key="timestamp"
                    @onChangeProduct="onChangeProduct"
                  ></sort-product>
                </template>
              </v-flex>
            </v-layout>

            <template v-if="!loadingProduct">
              <v-layout wrap v-if="categorylist && filterProducts && filterProducts.length > 0">
                <v-flex xs12 sm1>
                  <v-select
                    :items="pagelimit"
                    solo
                    v-model="size"
                    @change="onChangeLimit"
                    small
                    class="browser-default mb-2"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                    class="mb-2"
                  ></v-pagination>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex
                  xs12
                  sm6
                  md4
                  lg3
                  xl2
                  class="pa-1"
                  v-if="
                    !(
                      selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret
                    )
                  "
                >
                  <div
                    class="btn-add"
                    @click="onAddNewProduct"
                    style="position: relative; min-height: 360px; cursor: pointer; height: 100%"
                  >
                    <div style="position: absolute; top: 50%; margin-top: -30px; left: 0; right: 0">
                      <div class="text-xs-center">
                        <h3 class="headline" style="color: #969595">
                          <em class="fa fa-plus" />
                        </h3>
                        <p>{{ $t('Add new product') }}</p>
                      </div>
                    </div>
                    <template
                      v-if="
                        ($store.getters.getPackage != 'premium' || isCoachlab) &&
                        productlist.length >= maxProduct
                      "
                    >
                      <v-premium-plan-popup
                        :showAll="false"
                        marginTop="65"
                        :size="'small'"
                      ></v-premium-plan-popup>
                    </template>
                  </div>
                </v-flex>
                <template v-if="categorylist && filterProducts && filterProducts.length > 0">
                  <template v-for="(product, index) in filterProducts">
                    <v-flex xs12 sm6 md4 lg3 xl2 class="pa-1" :key="'product_' + product.id">
                      <product
                        @changeproductstatus="onChangeProductStatus"
                        v-model="filterProducts[index]"
                        @productDeleted="onDeleteProduct(index)"
                        :category="categorylist"
                        :selectCategory="currentCategory"
                        @onSelectedProduct="onSelectedProduct(index, product)"
                      ></product>
                    </v-flex>
                  </template>
                </template>
              </v-layout>

              <v-layout
                wrap
                v-if="categorylist && filterProducts && filterProducts.length > 0"
                class="mt-3"
              >
                <v-flex xs12 sm1>
                  <v-select
                    :items="pagelimit"
                    solo
                    v-model="size"
                    @change="onChangeLimit"
                    small
                    class="mb-2"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                    class="mb-2"
                  ></v-pagination>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <div style="padding: 30px 0">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="45px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <div class="mb-5 mt-5"></div>
          </template>
          <template v-else>
            <div class="text-xs-center" style="margin: 35px 0">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 300px" />
              <h3 class="headline">{{ $t('Select category') }}</h3>
              <v-btn depressed color="primary" @click="showCategory = true">
                {{ $t('Add new categories') }}
              </v-btn>
            </div>
          </template>
        </template>
        <categories
          v-model="filterCategory"
          @close="showCategory = false"
          :show="showCategory"
          :prefix="shop.name"
          @onCategoryChange="onCategoryChange"
          @deleteCategory="deleteCategory"
        ></categories>
      </v-container>
    </div>
    <div v-else-if="state == 'add-product'">
      <template v-if="categorylist && state == 'add-product'">
        <v-container>
          <modal-add-product
            :selectCategory="currentCategory"
            :category="filterCategory"
            @onAddProduct="addProduct"
            @close="close"
          ></modal-add-product>
        </v-container>
      </template>
    </div>
    <div v-else-if="state == 'edit-product'">
      <template v-if="categorylist && currentProduct">
        <v-container>
          <modal-edit-product
            v-model="currentProduct"
            @close="close"
            @onSaveProduct="closeEditProduct"
            :selectCategory="currentCategory"
            :category="filterCategory"
          ></modal-edit-product>
        </v-container>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Product from './Product'
import ModalAddProduct from './ModalAddProduct'
import ModalEditProduct from './ModalEditProduct'
import SelectCategory from './SelectCategory'
import FilterCategory from './FilterCategory'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import Categories from './Categories'
import ModalHelp from '@/components/elements/ModalHelp'
import TransferShop from './TransferShop.vue'
import SortProduct from './SortProduct.vue'
import moment from 'moment'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import ImportShop from './ImportShop.vue'
import Multiselect from 'vue-multiselect'

import api from '@/api'

export default {
  data: function () {
    return {
      showSortProduct: false,
      pageNumber: 1,
      size: 10,
      currentProduct: undefined,
      currentCategory: 'all',
      currentFilter: 'all',
      productlist: [],
      categorylist: undefined,
      selectedProduct: null,
      showCategory: false,
      showModal: false,

      loadingProduct: true,
      loadingCategory: true,

      pagelimit: [10, 25, 50],

      filterBadge: {
        all: 0,
        sales: 0,
        soldout: 0
      },

      productCount: 0,

      search: '',
      state: 'list',
      timestamp: moment().format('x'),
      shopOptions: [
        {
          name: 'Sukhumvit 49',
          lat_long: '13.7354205,100.5772363',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Surawong',
          lat_long: '13.725246, 100.516397',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Panya Village',
          lat_long: '13.830895, 100.675212',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Villa Aree',
          lat_long: '13.780025, 100.545236',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Samyan Mitr Town (G Flr)',
          lat_long: '13.733955, 100.528170',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Siam Paragon (G Flr)',
          lat_long: '13.746843, 100.534760',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Central Ladplao (B Flr)',
          lat_long: '13.816310, 100.560804',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Central Changwattana',
          lat_long: '13.903847, 100.528047',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Central Eastville (G Flr)',
          lat_long: '13.803088, 100.614778',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Central Rama 9 (B Flr)',
          lat_long: '13.758549, 100.566044',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'The Circle Rachapruk',
          lat_long: '13.767594, 100.442730',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'SB Rachapruk',
          lat_long: '13.808348, 100.447743',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Dentral Hospital',
          lat_long: '13.713760, 100.601317',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'The Cystral Ekkamai-Ramindra',
          lat_long: '13.811164, 100.618912',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'Central Westgate',
          lat_long: '13.876651, 100.412116',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'The Mall Bangkapi',
          lat_long: '13.766139, 100.642492',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'PTT Aomnoi',
          lat_long: '13.710679, 100.315389',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'PTT Puttasakorn (Arrival)',
          lat_long: '13.677225, 100.319170',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        },
        {
          name: 'PTT Puttasakorn (Departure)',
          lat_long: '13.676931, 100.320106',
          pictureurl:
            'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
        }
      ],
      shop: {
        name: 'Sukhumvit 49',
        lat_long: '13.7354205,100.5772363',
        pictureurl: 'https://zwizai.s3.amazonaws.com/ecommerce/1597649296015bank-account-kanom.jpg'
      }
    }
  },
  components: {
    Product,
    ModalAddProduct,
    ImportShop,
    ModalEditProduct,
    Categories,
    SelectCategory,
    ScaleLoader,
    FilterCategory,
    ModalHelp,
    TransferShop,
    SortProduct,
    Multiselect
  },
  mounted: function () {
    let vm = this
    // vm.$store.dispatch("loading")
    vm.getCategories(function () {
      if (vm.categorylist.length > 0) {
        vm.onChangeCategory(vm.categorylist[0])
      }
      vm.getProducts().then(() => {
        vm.loadingCategory = false
      })
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      isFacebook: 'isFacebook'
    }),
    filterCategory: {
      get() {
        if (!this.categorylist) {
          return []
        }
        return this.categorylist.filter((el) => {
          return el.name.toLowerCase().includes(this.shop.name.toLowerCase() + '/')
        })
      },
      set(val) {
        var categories = this.categorylist.filter((el) => {
          return !el.name.toLowerCase().includes(this.shop.name.toLowerCase() + '/')
        })
        this.categorylist = categories.concat(val)
      }
    },
    maxProduct() {
      return this.isCoachlab ? 20 : 10
    },
    filterProducts: function () {
      let products = []
      let vm = this
      var productlist = vm.productlist.filter((el) => {
        return (
          vm.filterCategory.findIndex((cat) => {
            return cat.id == el.categoryid
          }) != -1
        )
      })

      vm.filterBadge = {
        all: productlist.length,
        sales: 0,
        soldout: 0
      }

      $.each(productlist, function (index, val) {
        if (parseFloat(val.price) > parseFloat(val.discountprice)) {
        }
        if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
          vm.filterBadge.sales += 1
        } else {
          var isDiscount = false
          if (val.productstock) {
            val.productstock.map(function (stock, sindex) {
              if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                isDiscount = true
              }
            })
          }

          if (isDiscount) {
            vm.filterBadge.sales += 1
          }
        }
        if (vm.currentCategory === 'sales') {
          if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
            products.push(val)
          } else {
            if (val.productstock) {
              val.productstock.map(function (stock, sindex) {
                if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                  isDiscount = true
                }
              })
            }

            if (isDiscount) {
              products.push(val)
            }
          }
        } else if (vm.currentCategory === val.categoryid) {
          products.push(val)
        }
        if (val.productstock.length === 0) {
          vm.filterBadge.soldout += 1
          if (vm.currentCategory === 'soldout') {
            products.push(val)
          }
        } else {
          $.each(val.productstock, function (sindex, stock) {
            if (stock[2] <= 0) {
              vm.filterBadge.soldout += 1
              if (vm.currentCategory === 'soldout') {
                products.push(val)
              }
              return false
            }
          })
        }
      })
      if (vm.currentCategory === 'all') {
        products = productlist
      }

      var p = []
      if (vm.search === '') {
        p = products
      } else {
        p = products.filter((product) => {
          var isFoundSkuInStock = false
          if (product.productstock && product.productstock.length > 0) {
            var stocks = product.productstock.filter((stock) => {
              return (
                stock[5] &&
                stock[5] != null &&
                stock[5].toLowerCase().includes(vm.search.toLowerCase())
              )
            })
            isFoundSkuInStock = stocks.length > 0
          }
          return (
            product.name.toLowerCase().includes(vm.search.toLowerCase()) ||
            (product.code != null &&
              product.code.toLowerCase().includes(vm.search.toLowerCase())) ||
            isFoundSkuInStock
          )
        })
      }
      this.productCount = p.length

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    },
    pageCount: function () {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  methods: {
    onchangeshop(val) {
      this.pageNumber = 1
      this.currentCategory = 'all'
      $('html, body').animate({
        scrollTop: 0
      })
    },
    async close() {
      this.state = 'list'
      await this.$nextTick()
      goTo(0)
    },
    async onChangeProduct() {
      await this.getProducts()
      this.timestamp = moment().format('x')
    },
    onChangeLimit: function (value) {
      this.size = value
      this.pageNumber = 1
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onClickPageinate: function (pageNum) {
      this.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onAddNewProduct: function () {
      var vm = this
      if (
        (vm.$store.getters.getPackage === 'premium' && !vm.isCoachlab) ||
        (vm.$store.getters.getPackage !== 'premium' && vm.productlist.length < vm.maxProduct) ||
        (vm.isCoachlab && vm.productlist.length < vm.maxProduct)
      ) {
        vm.state = 'add-product'
      }
      this.timestamp = moment().format('x')
    },
    closeEditProduct: async function () {
      var vm = this
      await vm.getProducts()
      vm.$store.dispatch('loading')
      vm.state = 'list'
      this.timestamp = moment().format('x')
    },
    onSelectedProduct: function (index, product) {
      this.currentProduct = product
      this.state = 'edit-product'
    },
    onCategoryChange: function () {
      let vm = this
    },
    deleteCategory(categoryid) {
      this.productlist = this.productlist.filter((el) => {
        return el.categoryid != categoryid
      })
      if (this.currentCategory == categoryid) {
        this.currentCategory = 'all'
      }
    },
    getCategories: function (callback) {
      let vm = this
      vm.loadingCategory = true
      if (!vm.selectedBot) {
        return
      }
      var data = {
        pageid: vm.selectedBot.pageid
      }
      if (
        vm.selectedBot.useketshop == true &&
        vm.selectedBot.ketshop_api_key &&
        vm.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
      }
      api.getCategories(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.categorylist = response.categorylist
        callback()
      })
    },
    getProducts: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }
        let data = {
          pageid: vm.selectedBot.pageid
        }
        vm.loadingProduct = true
        vm.productlist = []
        if (
          vm.selectedBot.useketshop == true &&
          vm.selectedBot.ketshop_api_key &&
          vm.selectedBot.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
        }
        api.getProducts(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.loadingProduct = false
            resolve()
            return
          }
          vm.productlist = response.productlist
          vm.loadingProduct = false
          resolve()
        })
      })
    },
    addProduct: async function (product) {
      await this.getProducts()
      this.$store.dispatch('loading')
      this.timestamp = moment().format('x')

      // this.productlist.unshift({
      // 	id : product.id,
      // 	photourl : product.photourl,
      // 	name : product.name,
      // 	description : product.description,
      // 	price : product.price,
      // 	currency : product.currency,
      // 	categoryid : product.categoryid,
      // 	subcategoryid : product.subcategoryid,
      // 	keyword: product.keyword,
      // 	discountprice : product.discountprice,
      // 	code : product.code,

      // 	buttonaction : product.buttonaction,
      // 	buttonname : product.buttonname,
      // 	buttonurl : product.buttonurl,
      // 	productstock : product.productstock
      // })

      // this.productlist = Object.assign([],this.productlist)
    },
    onSelectProduct: function (val) {
      this.selectedProduct = this.productlist.find((product) => {
        return product.id == val
      })
    },
    onLoadCategory: function (payload) {
      // console.log(payload)
      if (payload && payload.length > 0) {
        // this.getProducts()
      }
    },
    onChangeCategory: function (payload) {
      this.currentCategory = 'all'
      this.currentFilter = 'all'
      this.search = ''
      this.pageNumber = 1
      // this.getProducts()
    },
    onDeleteProduct: function (index) {
      // vm.productlist.splice(index,1)
      this.getProducts()
      this.timestamp = moment().format('x')
    },
    onChangeProductStatus(payload) {
      var index = this.productlist.findIndex((el) => {
        return payload.id == el.id
      })
      this.$set(this.productlist[index], 'status', payload.status)
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    },
    showModal: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    showCategory: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    currentCategory: function (newVal, oldVal) {
      if (newVal != null) {
        this.pageNumber = 1
        // this.getProducts(function() {})
      }
    },
    productlist: function (newVal, oldVal) {
      let vm = this
      // $.each(vm.productlist,function(index ,val){
      // 	if (val.categoryid != vm.currentCategory.id) {
      // 		vm.productlist.splice(index,1)
      // 		return false;
      // 	}
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.ketshop-bg-color {
  background-color: rgb(58, 58, 58);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/KanomProducts.vue